// PrivacyPolicy.jsx

import React from 'react';
import Layout from '../Layout';
import { useSelector } from 'react-redux';
import BreadCrump from '../breadcrump/BreadCrump';
import Container from '../../ui/container/Container';

const PrivacyPolicy = () => {
  const setting = useSelector((state) => state.globalState.siteSetting.site_settings);

  return (
   <Layout>
<BreadCrump />
    <Container>
      <h1 className="text-2xl font-bold mb-6">Privacy Policy</h1>

      <p className="text-sm mb-4">
        This Privacy Policy describes how CineGuru and its affiliates (collectively "CineGuru", "we", "our", "us") collect, use, share, protect, or otherwise process your personal data through our website cineguru.in (referred to as the "Platform").
      </p>

      <p className="text-sm mb-4">
        By visiting this Platform, providing your information, or availing any product/service offered, you agree to be bound by this Privacy Policy, our Terms of Use, and applicable service/product terms. If you do not agree, please do not access or use the Platform.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-4">Information We Collect</h2>
      <p className="text-sm mb-4">
        We collect personal data when you register, use our services, or communicate with us. This includes but is not limited to your name, birth date, address, phone number, email ID, payment information, and biometric data (if applicable). Certain data may be collected automatically such as browsing behavior.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-4">How We Use Your Information</h2>
      <ul className="list-disc list-inside text-sm space-y-2 mb-4">
        <li>To provide, personalize, and improve our services.</li>
        <li>To handle orders, payments, and transactions.</li>
        <li>To resolve disputes and troubleshoot issues.</li>
        <li>To communicate offers, promotions, and updates.</li>
        <li>To prevent fraud and enforce our policies.</li>
        <li>To conduct analytics, research, and customer service.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-4">Sharing Your Data</h2>
      <p className="text-sm mb-4">
        We may share your data with our affiliates, service providers, sellers, logistics, payment processors, and law enforcement if required. Data is shared only as necessary to provide services, comply with legal obligations, or for business operations.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-4">Security Measures</h2>
      <p className="text-sm mb-4">
        We use reasonable security practices to protect your data. Despite this, transmission over the internet may not be completely secure. You are responsible for keeping your login information confidential.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-4">Data Retention & Deletion</h2>
      <p className="text-sm mb-4">
        We retain your data only as long as necessary or as required by law. You may request deletion of your data or account through your profile settings or by contacting us. Certain conditions (e.g., pending claims) may delay deletion.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-4">Your Rights</h2>
      <p className="text-sm mb-4">
        You can access, update, and correct your data through your account. You may withdraw consent by contacting our Grievance Officer.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-4">Consent</h2>
      <p className="text-sm mb-4">
        By using our Platform or providing data, you consent to collection, use, and disclosure per this Privacy Policy. If you share another person’s data, you represent that you have their permission.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-4">Changes to This Policy</h2>
      <p className="text-sm mb-4">
        We may update this Privacy Policy. Please check periodically for changes. We may notify you of significant updates as required by law.
      </p>

      <div className="mt-8 border-t pt-6 text-sm">
        <p><strong>Grievance Officer:</strong> CineGuru Administration</p>
        <p><strong>Address:</strong> CineGuru, 129, Kartik Building, Link Road, Andheri West, Mumbai</p>
        <p><strong>Phone: {setting?.site_phone} </strong> Monday - Friday (9:00 - 18:00)</p>
      </div>
    </Container>
    </Layout>
  );
};

export default PrivacyPolicy;
